import { ReversalHistoryKey } from '../../TModules';

export const translations = {
  [ReversalHistoryKey]: {
    Title: 'Reversal history',
    Administrator: 'Administrator',
    Source: 'Source',
    SourceTransactionReversal: 'Transaction reversal',
    SourceBulkAction: 'Bulk action',
    StatusSuccess: 'Success',
    StatusFailed: 'Failed',
    ExportCsv: 'Export CSV',
    Campaign: 'Campaign',
    TicketCode: 'Ticket code',
    Customer: 'Customer',
    Reason: 'Reason',
    Outcome: 'Outcome',
    FailureMessage: 'Failure message',
    ReversedOn: 'Reversed on',
    System: 'System',
    FilterCampaign: 'Filter by campaign',
    FilterAdministrator: 'Filter by administrator',
    FilterSource: 'Filter by source',
    FilterOutcome: 'Filter by outcome',
    ExportQueued: "Export queued — we'll email the CSV to {{email}}"
  }
};
